import { useEffect, useState } from 'react';
import { organizationService } from './services';

// The dealership name rarely changes, so one fetch per page load is shared by
// every caller (TopBar is mounted per page, SideNav once).
let orgNamePromise = null;
function loadOrgName() {
  if (!orgNamePromise) {
    orgNamePromise = organizationService.get()
      .then((o) => o?.name || o?.dealershipName || null)
      .catch(() => { orgNamePromise = null; return null; });
  }
  return orgNamePromise;
}

/** The signed-in user's dealership name, or null while loading / not permitted. */
export function useOrgName() {
  const [name, setName] = useState(null);
  useEffect(() => {
    let alive = true;
    loadOrgName().then((n) => { if (alive) setName(n); });
    return () => { alive = false; };
  }, []);
  return name;
}
